import React from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";

// common
import {
  ProgramSelectorContainer,
  ProgramOption,
  ProgramInfoContainer,
  ProgramDescription,
  Price,
  CurrencySign,
  PerUnitTime,
} from "common/program_selector";
import { ModalLayout, MoreModalButtons } from "common/modal";

// styling
import { Program } from "types";
import getCurrencySign from "utils/currency";
import outputManuallySetPrice from "utils/outputManuallySetPrice";
import resizeOverflowingPrice from "utils/resizeOverflowingPrice";
import { FormCard, CardTitle } from "./RegistrationStyle";
import { ConfirmationCardInfo } from "./ConfirmationStyle";

// types

const { ModalRow, ModalCol } = ModalLayout;
const { ButtonContainer, ModalButtonYellow } = MoreModalButtons;

type ConfirmationProps = {
  handleClickBookAClass: () => void;
  chosenProgram: Program;
  subscriptionEndDate: string;
};

const Confirmation = ({
  handleClickBookAClass,
  chosenProgram,
  subscriptionEndDate,
}: ConfirmationProps) => {
  const { t } = useTranslation("registration");

  return (
    <FormCard>
      <CardTitle>{t("PAYMENT SUCCESSFUL")}</CardTitle>
      <ProgramSelectorContainer value={chosenProgram.id}>
        <ProgramOption value={chosenProgram.id} checked>
          <ProgramInfoContainer>
            <ProgramDescription sm={16} xs={12}>
              <div style={{ whiteSpace: "normal", textAlign: "left" }}>
                {chosenProgram.name}
              </div>
            </ProgramDescription>
            <Price
              sm={8}
              xs={12}
              style={{
                fontSize: resizeOverflowingPrice(
                  outputManuallySetPrice(chosenProgram.price)
                ),
              }}
            >
              <CurrencySign>
                <span // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{
                    __html: getCurrencySign(chosenProgram.currency),
                  }}
                />
              </CurrencySign>
              {outputManuallySetPrice(chosenProgram.price)}

              <PerUnitTime>{t("/month")}</PerUnitTime>
            </Price>
          </ProgramInfoContainer>
        </ProgramOption>
      </ProgramSelectorContainer>

      {/** TODO: Make payment date dynamic  */}
      <ConfirmationCardInfo>
        {t("Next payment will be charged on {{ date }}", {
          date: moment(subscriptionEndDate).format("ll"),
        })}
      </ConfirmationCardInfo>
      <ConfirmationCardInfo>
        {t("You can change your subscription in User Settings")}
      </ConfirmationCardInfo>

      <ModalRow style={{ marginBottom: "16px" }}>
        <ButtonContainer xs={20} sm={20} md={12}>
          <ModalButtonYellow type="primary" onClick={handleClickBookAClass}>
            {t("BOOK A CLASS")}
          </ModalButtonYellow>
        </ButtonContainer>
        <ModalCol xs={0} sm={0} md={12} />
      </ModalRow>
    </FormCard>
  );
};

export default Confirmation;
